import React, { useEffect, useState } from 'react';
import { Box, Text } from "@mantine/core";
import { userAuth } from '../../utils/Authorization';

interface NavbarSectionProps {
    title: string;
    requiredRoles?: string[];
    anyRole?: boolean;
    children?: React.ReactNode
}

/**
 * Creates a new Navbar Section, requires Navbar component
 * @param title - title of the section
 * @param requiredRoles - an optional array to hold the roles required to view this section
 * @param anyRole - default is true, matches any role in requiredRoles. Set to false to require all the roles
 */
function NavbarSection({ title, requiredRoles, anyRole, children }: NavbarSectionProps) {
    const [authorized, setAuthorized] = useState<boolean>(true);

    useEffect(() => {
        if (requiredRoles) {
            setAuthorized(userAuth.hasRequiredRoles(requiredRoles, anyRole));
        }
    }, [requiredRoles, anyRole]);

    return (
        <Box pb={24} display={authorized ? "block" : "none"}>
            <Text size={"0.8125em"} fw={500} c="var(--text-dimmed)" ml={8} mb={8}>{title}</Text>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {React.Children.map(children, (item) => (
                    <li style={{ marginBottom: "4px" }}>
                        {item}
                    </li>
                ))}
            </ul>
        </Box>
    )
}

export default NavbarSection;